import React, { Component } from "react";
import axios from "axios";
import styled from "styled-components";
import { withRouter } from "react-router-dom";

import CS from "../../commons/services/Common";
import PageTitle from "../../commons/components/PageTitle";
import InputErrorMsgWrapper from "../../commons/components/input/InputErrorWrap";
import { ROUTES } from "../../commons/constants/routes/routes";

class FirmwareForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editId: null,
      version: "",
      bigo: "",
      existingFilename: "",
      file: null,
      validationErrors: {},
      isSubmitting: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const parts = window.location.pathname.split("/");
    const editIdx = parts.indexOf("edit");
    if (editIdx !== -1 && parts[editIdx + 1]) {
      const id = parts[editIdx + 1];
      this.setState({ editId: id });

      const item = this.props.location.state && this.props.location.state.item;
      if (item) {
        this.applyItem(item);
      } else {
        this.loadItem(id);
      }
    }
  }

  applyItem(item) {
    this.setState({
      version: item.version || "",
      bigo: item.bigo || "",
      existingFilename: item.filename || "",
    });
  }

  // 단건 조회 API가 없어 목록에서 id로 찾아 채운다.
  async loadItem(id) {
    try {
      const res = await axios.get("/api/v1/rtu/ota");
      const item = (res.data.data || []).find((row) => String(row.id) === String(id));
      if (item) this.applyItem(item);
    } catch (e) {
      console.log(e);
    }
  }

  validateForm() {
    const { editId, version, file } = this.state;
    const validationErrors = {};
    if (!editId && !version.trim()) validationErrors.version = "버전을 입력해주세요.";
    if (!editId && !file) validationErrors.file = "펌웨어 파일을 선택해주세요.";
    if (Object.keys(validationErrors).length > 0) {
      this.setState({ validationErrors });
      return false;
    }
    return true;
  }

  async handleSubmit(e) {
    e.preventDefault();
    if (!this.validateForm()) return;

    const { editId, version, bigo, file } = this.state;
    this.setState({ isSubmitting: true });

    try {
      const formData = new FormData();
      if (editId) formData.append("id", editId);
      if (version.trim()) formData.append("version", version.trim());
      formData.append("bigo", bigo);
      if (file) formData.append("file", file);

      const result = editId
        ? await CS.update("/api/v1/rtu/ota", formData)
        : await CS.create("/api/v1/rtu/ota", formData);

      if (result.isSuccess) {
        this.props.history.push(ROUTES.FIRMWARE.MAIN);
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.setState({ isSubmitting: false });
    }
  }

  clearError(field) {
    const { validationErrors } = this.state;
    delete validationErrors[field];
    this.setState({ validationErrors });
  }

  render() {
    const {
      editId,
      version,
      bigo,
      existingFilename,
      file,
      validationErrors,
      isSubmitting,
    } = this.state;
    const isEdit = !!editId;

    return (
      <>
        <PageTitle title="펌웨어 관리" location={isEdit ? "펌웨어 수정" : "펌웨어 등록"} />
        <FormWrapper onSubmit={this.handleSubmit}>
          <FormContainer>
            <FormBox>
              <FormHead required={!isEdit}>버전</FormHead>
              <FormBody>
                <InputErrorMsgWrapper
                  isError={validationErrors.version}
                  message={validationErrors.version}
                >
                  <input
                    type="text"
                    className="comm-inp"
                    placeholder="예) 1.0.3"
                    value={version}
                    onChange={(e) => {
                      this.clearError("version");
                      this.setState({ version: e.target.value });
                    }}
                  />
                </InputErrorMsgWrapper>
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead>비고</FormHead>
              <FormBody>
                <input
                  type="text"
                  className="comm-inp"
                  placeholder="비고를 입력하세요"
                  value={bigo}
                  onChange={(e) => this.setState({ bigo: e.target.value })}
                />
              </FormBody>
            </FormBox>

            <FormBox>
              <FormHead required={!isEdit}>펌웨어 파일</FormHead>
              <FormBody>
                <InputErrorMsgWrapper
                  isError={validationErrors.file}
                  message={validationErrors.file}
                >
                  <input
                    type="file"
                    onChange={(e) => {
                      this.clearError("file");
                      this.setState({ file: e.target.files[0] || null });
                    }}
                  />
                  {isEdit && existingFilename && (
                    <CurrentFile>
                      현재 파일: {existingFilename}
                      {file ? " (새 파일로 교체됩니다)" : ""}
                    </CurrentFile>
                  )}
                </InputErrorMsgWrapper>
              </FormBody>
            </FormBox>
          </FormContainer>

          <BtnGroup>
            <button
              type="button"
              onClick={() => this.props.history.push(ROUTES.FIRMWARE.MAIN)}
            >
              취소
            </button>
            <button type="submit" disabled={isSubmitting}>
              {isEdit ? "수정" : "저장"}
            </button>
          </BtnGroup>
        </FormWrapper>
      </>
    );
  }
}

const FormWrapper = styled.form`
  width: 1176px;
  margin: 55px auto 120px;
`;
const FormContainer = styled.div`
  max-width: 1176px;
  width: 100%;
  margin: 55px auto 20px;
  border: 1px solid #4b515b;
  border-width: 1px 0 1px;
`;
const FormBox = styled.div`
  padding: 24px 0;
  border-bottom: 1px solid #e3e5e7;
  display: flex;
  align-items: flex-start;
`;
const FormHead = styled.p`
  width: 140px;
  flex-shrink: 0;
  font-size: 16px;
  color: #191919;
  font-weight: 600;
  padding-left: 12px;
  padding-top: 8px;
  ${({ required }) =>
    required &&
    `&::after {
      content: " *";
      color: #FF5353;
    }`}
`;
const FormBody = styled.div`
  flex: 1;
  input,
  select {
    border-radius: 4px;
  }
  .comm-inp {
    width: 700px;
  }
`;
const CurrentFile = styled.p`
  margin-top: 8px;
  font-size: 13px;
  color: #888e98;
`;
const BtnGroup = styled.div`
  max-width: 1176px;
  width: 100%;
  text-align: right;
  margin: 0 auto;
  button {
    width: 120px;
    font-size: 14px;
    padding: 10px 0;
    text-align: center;
    border-radius: 5px;
    font-weight: 600;
    cursor: pointer;
    &:first-child {
      color: var(--secondary-500);
      background-color: transparent;
      border: 1px solid var(--secondary-500);
    }
    &:last-child {
      margin-left: 12px;
      color: var(--grey-900);
      background-color: var(--primary-500);
      border: 1px solid var(--primary-500);
      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }
  }
`;

export default withRouter(FirmwareForm);
